import { en } from './en'

export const de = {
	...en,
  meta: {
    title: 'AuthFlow™ - Einfache E-Mail/Passwort-Authentifizierung mit JWT-Tokens',
    description: 'Zuverlässige E-Mail/Passwort-Authentifizierung mit JWT-Tokens für moderne Webanwendungen. Anders als komplexe Plattformen konzentrieren wir uns auf das, was funktioniert: ein sicherer, einfacher Login, dem Entwickler vertrauen können.',
  },
	nav: {
		home: 'Startseite',
		features: 'Funktionen',
		pricing: 'Preise',
		compare: 'Vergleichen',
		contact: 'Kontakt',
		getStarted: 'Loslegen',
		signIn: 'Anmelden',
	},
	hero: {
		badge: 'Weltweit von DevSecOps-Teams vertraut',
		title: 'Authentifizierung',
		subtitle: 'Richtig gemacht',
		description: 'Die beste, schnellste und sicherste E-Mail/Passwort-Authentifizierung. Statt ueberkomplexer Plattformen konzentrieren wir uns auf das Wesentliche: sichere JWT-Authentifizierung, die einfach funktioniert.',
		startTrial: 'Kostenlos testen',
		getStarted: 'Loslegen',
			trialNote: 'Keine Kreditkarte erforderlich • 10 Monatlich Aktive Nutzer kostenlos',
		metrics: {
			firstIntegrationValue: '5 Min',
			firstIntegrationLabel: 'bis zur ersten Integration',
			predictableSessionsValue: 'JWT',
			predictableSessionsLabel: 'Session-Logik, die berechenbar bleibt',
			noMazeValue: 'Kein Labyrinth',
			noMazeLabel: 'fuer Teams, die einfach funktionierende Auth brauchen',
		},
		missionControlLabel: 'Auth-Leitstand',
		missionControlTitle: 'Benutzer authentifizieren – ohne Irrgarten',
		missionControlStatus: 'Stabil',
		sessionLayer: 'Session-Schicht',
		emailPasswordSignIn: 'E-Mail/Passwort-Anmeldung',
		roleAwareVerification: 'Rollenbasierte Verifizierung',
		validated: 'validiert',
		live: 'live',
		integrationShapeLabel: 'Integrationsform',
		integrationShapeValue: 'Kleine API, klarer Ablauf',
		forTeamsLabel: 'Fuer Teams',
		forTeamsValue: 'Produkt liefern statt IAM-Projekte bauen',
	},
	cta: {
		title: 'Bereit fuer zuverlaessige Authentifizierung?',
		description: 'Schliess dich Teams an, die auf einfache E-Mail/Passwort-Authentifizierung mit JWT setzen. Starte heute deine kostenlose Testphase.',
		startTrial: 'Kostenlos testen',
	},
	dashboard: {
		title: 'Dashboard',
		users: 'Benutzer',
		activity: 'Aktivitaet',
		settings: 'Einstellungen',
		logout: 'Abmelden',
		profileSettings: 'Profileinstellungen',
		activityLog: 'Aktivitaetsprotokoll',
		welcome: 'Willkommen in deinem Dashboard',
		welcomeBack: 'Willkommen zurueck, {name}. Hier ist der aktuelle Status deines Authentifizierungsdienstes.',
		totalUsers: 'Gesamtbenutzer',
		activeUsers: 'Aktive Benutzer',
		totalLogins: 'Gesamtanmeldungen',
		recentActivity: 'Letzte Aktivitaet',
		noRecentActivity: 'Keine aktuelle Aktivitaet',
		userSettings: 'Benutzereinstellungen',
		organizationOwnerCannotBeManaged: 'Organisationsinhaber kann nicht verwaltet werden',
		configureSettings: 'Einstellungen konfigurieren',
		hereIsWhatsHappening: 'Das passiert gerade mit deinem Authentifizierungsdienst.',
		fromLastMonth: 'gegenueber letztem Monat',
		monthlyLogins: 'Monatliche Logins',
		successRate: 'Erfolgsquote',
		latestAuthEvents: 'Neueste Authentifizierungsereignisse und System-Updates',
		viewAllActivity: 'Alle Aktivitaeten anzeigen',
		userManagement: 'Benutzerverwaltung',
		manageApplicationUsers: 'Verwalte die Benutzer deiner Anwendung',
		viewAllUsers: 'Alle Benutzer anzeigen',
		apiKeys: 'API-Schluessel',
		manageApiKeys: 'Verwalte deine Authentifizierungs-API-Schluessel',
		systemStatus: 'Systemstatus',
		authenticationApi: 'Authentifizierungs-API',
		operational: 'Betriebsbereit',
		userManagementService: 'Benutzerverwaltung',
		searchUsers: 'Benutzer suchen...',
		all: 'Alle',
		active: 'Aktiv',
		inactive: 'Inaktiv',
		lastLogin: 'Letzter Login',
		never: 'Nie',
		admin: 'Admin',
		owner: 'Inhaber',
		noUsersFound: 'Keine Benutzer fuer diese Filter gefunden',
		noUsers: 'Keine Benutzer gefunden',
		for: 'fuer',
		noApiKeyFound: 'Kein API-Schluessel gefunden',
		hideApiKey: 'API-Schluessel ausblenden',
		showApiKey: 'API-Schluessel anzeigen',
		created: 'Erstellt',
		success: 'Erfolg',
		warning: 'Warnung',
		info: 'Info',
		system: 'System',
		justNow: 'gerade eben',
		minutesAgo: 'Minuten zuvor',
		hoursAgo: 'Stunden zuvor',
		daysAgo: 'Tage zuvor',
		notifications: 'Benachrichtigungen',
		billingReminder: 'Abrechnungserinnerung',
		noNewNotifications: 'Keine neuen Benachrichtigungen',
		logOut: 'Abmelden',
	},
	about: {
		title: 'Ueber AuthFlow™ - Experten fuer einfache E-Mail/Passwort-Authentifizierung',
		description: 'Erfahre mehr ueber die Mission von AuthFlow™, zuverlaessige E-Mail/Passwort-Authentifizierung mit JWT-Tokens bereitzustellen. Seit 2023 machen wir sicheres Login fuer Entwickler einfach.',
		keywords: ['email passwort authentifizierung', 'JWT authentifizierungs firma', 'authentifizierungs experten', 'einfache authentifizierung', 'sicheres login firma', 'entwickler authentifizierung', 'zuverlaessige authentifizierung', 'token-basierte authentifizierung', 'web app sicherheit', 'authentifizierungs plattform'],
		ogTitle: 'Ueber AuthFlow™ - Experten fuer einfache E-Mail/Passwort-Authentifizierung',
		ogDescription: 'Lerne unsere Mission kennen: zuverlaessige E-Mail/Passwort-Authentifizierung mit JWT-Tokens. Statt komplexer Plattformen fokussieren wir uns auf das, was funktioniert.',
		hero: {
			badge: 'Gegruendet 2023',
			title: 'Wir bauen die Zukunft von',
			titleAccent: 'einfacher Authentifizierung',
			description: 'Unsere Mission ist es, E-Mail/Passwort-Authentifizierung mit JWT-Tokens fuer jeden Entwickler zugaenglich zu machen und die Komplexitaet beim Eigenbau von Auth zu beseitigen.',
		},
		mission: {
			title: 'Unsere Mission',
			description1: 'Sichere, token-basierte Authentifizierung zu demokratisieren, die leicht implementierbar und wartbar ist.',
			description2: 'Wir priorisieren Datenschutz und Compliance by Design mit minimaler Datenerhebung und starker Verschluesselung.',
			description3: 'So koennen sich Entwickler auf grossartige Produkte konzentrieren statt auf ueberkomplexe Auth-Infrastruktur.',
		},
		vision: {
			title: 'Unsere Vision',
			description1: 'Eine Welt, in der Authentifizierung einfach und zuverlaessig ist.',
			description2: 'Durch kontinuierliche Innovation bauen wir eine sichere, einfache Login-Infrastruktur, auf die Entwickler vertrauen koennen.',
		},
		values: {
			title: 'Unsere Werte',
			subtitle: 'Die Prinzipien, die alles bei AuthFlow™ leiten.',
			reliableSecurity: {
				title: 'Zuverlaessige Sicherheit',
				description: 'Bewaehrte Sicherheitspraktiken, die funktionieren - ohne unnoetige Komplexitaet.',
			},
			developerFirst: {
				title: 'Developer-First API',
				description: 'Wir legen Wert auf intuitive, gut dokumentierte Tools fuer eine hervorragende Developer Experience.',
			},
			communityDriven: {
				title: 'Community-getrieben',
				description: 'Unsere Roadmap wird durch Entwickler-Feedback aus realen Sicherheitsanforderungen geformt.',
			},
		},
		team: {
			title: 'Unser Team',
			subtitle: 'Leidenschaftliche Menschen hinter der Zukunft der Authentifizierung.',
			alex: {
				initials: 'AJ',
				name: 'Alex Johnson',
				role: 'CEO & Co-Founder',
				bio: 'Ehemaliger DevSecOps-Ingenieur bei einem grossen multinationalen Finanzinstitut.',
			},
			sarah: {
				initials: 'SC',
				name: 'Sarah Chen',
				role: 'CTO & Co-Founder',
				bio: 'Full-Stack-Architektin mit 10+ Jahren Erfahrung in zuverlaessigen Authentifizierungssystemen.',
			},
			marcus: {
				initials: 'MR',
				name: 'Marcus Rodriguez',
				role: 'Head of Product',
				bio: 'Produktleiter mit Fokus auf Developer Experience und einfache, effektive Login-Systeme.',
			},
		},
		stats: {
			title: 'AuthFlow™ in Zahlen',
			developers: 'Entwickler vertrauen uns',
			authentications: 'Monatliche Authentifizierungen',
			uptime: 'Verfuegbarkeit',
			monitoring: 'Sicherheitsmonitoring',
		},
		cta: {
			title: 'Werde Teil unserer Mission',
			description: 'Bereit fuer die Authentifizierungs-Revolution? Starte heute mit zuverlaessiger E-Mail/Passwort-Authentifizierung.',
			getStarted: 'Kostenlos loslegen',
			contactUs: 'Kontakt',
		},
		breadcrumb: {
			company: 'Unternehmen',
			aboutUs: 'Ueber uns',
		},
	},
	getStarted: {
		...en.getStarted,
		title: 'AuthFlow™ Loslegen - Setup-Anleitung fuer E-Mail/Passwort-Authentifizierung | JWT API Integration',
		description: 'Vollstaendige Anleitung zur Implementierung von E-Mail/Passwort-Authentifizierung mit AuthFlow™. Richte sicheres JWT-Login in wenigen Minuten ein.',
		keywords: ['authentifizierung setup', 'email passwort authentifizierung', 'JWT integration', 'sicheres login leitfaden', 'developer authentifizierung', 'API auth tutorial', 'token-basierte authentifizierung', 'auth API leitfaden'],
		ogTitle: 'AuthFlow™ Loslegen - Setup-Anleitung fuer E-Mail/Passwort-Authentifizierung | JWT API Integration',
		ogDescription: 'Implementiere E-Mail/Passwort-Authentifizierung mit AuthFlow™ und richte JWT-Tokens in wenigen Minuten ein.',
		breadcrumb: {
			resources: 'Ressourcen',
			getStarted: 'Loslegen',
		},
		hero: {
			...en.getStarted.hero,
			badge: 'Schnelle Setup-Anleitung',
			title: 'Starte mit',
			titleAccent: 'E-Mail/Passwort-Authentifizierung',
			description: 'Fuege deiner App in wenigen Minuten sicheres E-Mail/Passwort-Login hinzu.',
			createAccount: 'Kostenloses Konto erstellen',
		},
		steps: {
			...en.getStarted.steps,
			title: 'Drei einfache Schritte zur sicheren E-Mail/Passwort-Authentifizierung',
			subtitle: 'Integriere AuthFlow™ Endpunkte in dein Backend.',
			step1: { ...en.getStarted.steps.step1, title: 'Konto erstellen', description: 'Registriere dich bei AuthFlow™ und erstelle dein erstes Projekt.', signUp: 'Kostenlos registrieren', viewDemo: 'Demo ansehen' },
			step2: {
				...en.getStarted.steps.step2,
				title: 'Auth-Endpunkte integrieren',
				description: 'Nutze unsere /auth Endpunkte in deinem Backend.',
				features: {
					...en.getStarted.steps.step2.features,
					apiKeyRequired: 'API-Schluessel erforderlich',
					apiKeyDescription: 'Alle /auth Endpunkte benoetigen den API-Schluessel deiner Organisation im JWT-Kontext.',
					backendIntegration: 'Backend-Integration',
					backendDescription: 'Nur aus serverseitigem Code aufrufen und API-Schluessel nie im Frontend exponieren.',
					sessionManagement: 'Session-Management',
					sessionDescription: 'Verwalte Benutzersessions mit JWT-Tokens fuer zuverlaessige E-Mail/Passwort-Authentifizierung.',
				},
			},
			step3: { ...en.getStarted.steps.step3, title: 'Authentifizierung aktivieren', description: 'Verbinde deine App und starte mit der Authentifizierung.', quickStart: 'Schnellstart', fullDocumentation: 'Vollstaendige Dokumentation' },
		},
		apiDocs: {
			...en.getStarted.apiDocs,
			title: '/auth API-Endpunkte Technischer Leitfaden',
			subtitle: 'Technische Dokumentation zur Backend-Integration von AuthFlow™.',
			apiKeySetup: {
				...en.getStarted.apiDocs.apiKeySetup,
				title: 'API-Schluessel-Konfiguration',
				description: 'Der API-Schluessel deiner Organisation wird in JWT-Tokens fuer /auth Endpunkte eingebettet. Speichere ihn sicher in Backend-Umgebungsvariablen.',
				envVars: '# Umgebungsvariablen',
				securityNote: 'Sicherheitshinweis: API-Schluessel niemals im Frontend oder clientseitigem JavaScript offenlegen. /auth Aufrufe muessen vom Backend-Server kommen.',
			},
			implementation: { ...en.getStarted.apiDocs.implementation, title: 'Vollstaendiges Backend-Integrationsbeispiel', notes: 'Implementierungshinweise:', note1: 'Session-Tokens sicher speichern (HTTP-only Cookies empfohlen)', note2: 'Sessions auf geschuetzten Routen vor Verarbeitung validieren', note3: 'Token-Ablauf und Erneuerung behandeln', note4: 'Authentifizierungsereignisse fuer Security-Monitoring protokollieren' },
			errorHandling: {
				...en.getStarted.apiDocs.errorHandling,
				title: 'Fehlerbehandlung & Sicherheit',
				statusCodes: 'Gaengige HTTP-Statuscodes:',
				status200: '200: Erfolg',
				status400: '400: Bad Request (fehlende/ungueltige Parameter)',
				status401: '401: Unauthorized (ungueltige Tokens, falscher API-Schluessel usw.)',
				status404: '404: Benutzer nicht gefunden',
				status409: '409: Organisation existiert bereits (Sign-up)',
				status500: '500: Serverfehler',
				securityPractices: 'Sicherheits-Best-Practices:',
				practice1: 'JWT-Tokens immer vor der Anfrageverarbeitung validieren',
				practice2: 'HTTPS fuer alle API-Aufrufe verwenden',
				practice3: 'Rate Limiting auf Auth-Endpunkten implementieren',
				practice4: 'Session-Tokens in HTTP-only Secure Cookies speichern',
				practice5: 'Alle Auth-Versuche fuer Security-Monitoring protokollieren',
				practice6: 'Nie sensible Daten wie Passwoerter oder API-Schluessel loggen',
				criticalNote: 'Kritisch: Alle /auth Endpunkte duerfen nur vom Backend-Server aufgerufen werden. Niemals API-Schluessel im Client expose.',
			},
		},
		features: {
			...en.getStarted.features,
			title: 'Was du mit E-Mail/Passwort-Authentifizierung sofort bekommst',
			subtitle: 'Du verbindest die Endpunkte, wir liefern zuverlaessige JWT-Sessions.',
		},
		cta: {
			...en.getStarted.cta,
			title: 'Bereit fuer zuverlaessige E-Mail/Passwort-Authentifizierung?',
			description: 'Starte heute deine Testphase und bringe JWT-Authentifizierung noch heute live.',
			createAccount: 'Kostenloses Konto erstellen',
			talkToSales: 'Vertrieb kontaktieren',
		},
		parameters: 'Parameter',
		response: 'Antwort',
		example: 'Beispiel',
		runFailureScenario: 'Als Fehlerszenario ausfuehren',
		failureScenarioOn: 'Fehlerszenario: Aktiv',
		running: 'Laeuft...',
		runCurlConsole: 'cURL in Konsole ausfuehren',
		copied: 'Kopiert!',
		copyCurl: 'curl kopieren',
		copyBackendExample: 'Backend-Code kopieren',
		required: 'erforderlich',
		optional: 'optional',
		consoleRunning: 'Konsole laeuft...',
		consoleDemoTitle: 'Linux-Konsolen-Demo',
		consoleShellLabel: 'bash -- AuthFlow™ Konsole',
		notesTitle: 'Hinweise',
		endpointContent: {
			session: {
				fooBar: {
					summary: 'Erzeuge ein kurzlebiges Anti-Abuse-Token vor Sign-up oder Login.',
					params: {
						identity: 'E-Mail-Adresse des Auth-Benutzers.',
						apiKey: 'Organisations-API-Schluessel aus dem AuthFlow™ Owner-Dashboard.',
						role: 'RBAC-Rolle fuer das temporaere Token. Standard ist user.',
					},
					notes: {
						expires: 'Dieses Token laeuft nach 45 Sekunden ab.',
						freshToken: 'Hole unmittelbar vor Sign-up oder Login immer ein frisches fooBar-Token.',
					},
				},
				signUp: {
					summary: 'Erstelle einen neuen Auth-Benutzer innerhalb der Owner-Organisation.',
					params: {
						foobar: 'Temporäres Anti-Abuse-Token von /auth/fooBar.',
						email: 'E-Mail-Adresse des Benutzers.',
						password: 'Passwort gemaess {passwordRule}.',
						fullname: 'Vollstaendiger Name des Auth-Benutzers.',
						role: 'RBAC-Rolle des Benutzers in deiner Anwendung.',
						apiKey: 'Organisations-API-Schluessel.',
						disclaimed: 'Boolean-aehnlicher Wert im Benutzerdatensatz. In der Collection: true.',
					},
					notes: {
						successToken: 'Bei erfolgreichem Sign-up wird sofort ein Session-Token zurueckgegeben.',
						duplicateRole: 'Wenn dieselbe E-Mail und Rolle bereits existieren, antwortet die API mit 409.',
					},
				},
				login: {
					summary: 'Authentifiziere einen Auth-Benutzer und erhalte Session-Token oder 2FA-Challenge.',
					params: {
						foobar: 'Temporäres Anti-Abuse-Token von /auth/fooBar.',
						email: 'E-Mail-Adresse des Benutzers.',
						password: 'Benutzerpasswort.',
						apiKey: 'Organisations-API-Schluessel.',
						role: 'Benutzerrolle fuer den RBAC-Login.',
					},
					notes: {
						tempTokenInsteadOfToken: 'Wenn 2FA aktiv ist, liefert login ein tempToken statt token.',
						exchangeThrough2fa: 'tempToken wird danach ueber passende /auth/2fa-Verifizierungsrouten eingetauscht.',
					},
				},
				validate: {
					summary: 'Validiere ein Session-Token eines Auth-Benutzers.',
					params: {
						sessionToken: 'RS512 JWT Session-Token.',
						email: 'E-Mail-Adresse des Benutzers.',
					},
				},
				me: {
					summary: 'Gib das aktuelle Auth-Benutzerprofil fuer eine gueltige Session zurueck.',
					params: {
						sessionToken: 'RS512 JWT Session-Token.',
					},
				},
				logout: {
					summary: 'Melde den aktuellen Auth-Benutzer ab.',
					params: {
						sessionToken: 'RS512 JWT Session-Token.',
						email: 'E-Mail-Adresse des Benutzers.',
					},
				},
			},
			passwordManagement: {
				forgotPassword: {
					summary: 'Fordere eine Passwort-Reset-E-Mail fuer einen Auth-Benutzer an (enumeration-safe).',
					params: {
						email: 'Auth-Benutzer E-Mail-Adresse.',
						apiKey: 'Organisations-API-Schluessel.',
						role: 'Auth-Benutzerrolle. Standard ist user.',
					},
				},
				resetPassword: {
					summary: 'Setze das Passwort eines Auth-Benutzers mit gueltigem Reset-Token zurueck.',
					params: {
						token: 'Passwort-Reset-Token aus dem E-Mail-Link.',
						newPassword: 'Neues Passwort gemaess {passwordRule}.',
					},
				},
				changePassword: {
					summary: 'Aendere das Passwort des authentifizierten Auth-Benutzers.',
					params: {
						sessionToken: 'Aktuelles RS512 JWT Session-Token.',
						email: 'Im Session-Token kodierte E-Mail.',
						oldPassword: 'Aktuelles Passwort zur Bestaetigung.',
						newPassword: 'Neues Passwort gemaess {passwordRule}.',
					},
				},
			},
			emailVerification: {
				verifyEmail: {
					summary: 'Verifiziere die Auth-Benutzer-E-Mail ueber den Token aus der AuthFlow™ E-Mail.',
					params: {
						token: 'Verifizierungs-Token aus dem E-Mail-Verifizierungslink.',
					},
					notes: {
						openedFromEmail: 'Dieser Endpunkt wird ueblicherweise durch Klick auf den Link in der E-Mail geoeffnet.',
						frontendHostedProxy: 'AuthFlow™ unterstuetzt auch frontend-gehostete Verifizierung ueber /verify-email.',
					},
				},
				resendVerifyEmail: {
					summary: 'Sende die Verifizierungs-E-Mail erneut, wenn das Konto noch nicht verifiziert ist.',
					params: {
						foobar: 'Temporäres Token von /auth/fooBar.',
						email: 'Auth-Benutzer E-Mail-Adresse.',
						apiKey: 'Organisations-API-Schluessel.',
						role: 'Auth-Benutzerrolle. Standard ist user.',
					},
				},
			},
			twoFactor: {
				enable: {
					summary: 'Erzeuge ein TOTP-Secret und QR-Code fuer einen Auth-Benutzer.',
					params: {
						sessionToken: 'Aktuelles Session-Token.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
					},
				},
				verifySetup: {
					summary: 'Verifiziere den initialen TOTP-Code und aktiviere 2FA.',
					params: {
						sessionToken: 'Aktuelles Session-Token.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						totpCode: 'Sechsstelliger Code aus der Authenticator-App.',
						secret: 'TOTP-Secret aus /auth/2fa/enable.',
					},
				},
				disable: {
					summary: 'Deaktiviere TOTP-2FA fuer einen Auth-Benutzer.',
					params: {
						sessionToken: 'Aktuelles Session-Token.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						password: 'Aktuelles Passwort.',
					},
				},
				verify2fa: {
					summary: 'Tausche login tempToken und TOTP-Code gegen ein Session-Token.',
					params: {
						tempToken: 'tempToken von /auth/login wenn 2FA aktiv ist.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						totpCode: 'Sechsstelliger Authenticator-Code.',
					},
				},
				backupEmail: {
					summary: 'Sende ein Backup-E-Mail-OTP ueber ein login tempToken.',
					params: {
						tempToken: 'tempToken von /auth/login.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
					},
				},
				verifyEmailOtp: {
					summary: 'Tausche ein per E-Mail gesendetes OTP gegen ein Session-Token.',
					params: {
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						emailOtp: 'Sechsstelliger Code aus der E-Mail.',
					},
				},
				recoveryCodes: {
					summary: 'Generiere Recovery-Codes fuer einen Auth-Benutzer neu.',
					params: {
						sessionToken: 'Aktuelles Session-Token.',
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						password: 'Aktuelles Passwort.',
					},
				},
				verifyRecovery: {
					summary: 'Tausche einen Recovery-Code gegen ein Session-Token.',
					params: {
						email: 'Auth-Benutzer E-Mail.',
						apiKey: 'Organisations-UUID.',
						role: 'Auth-Benutzerrolle.',
						recoveryCode: 'Einer der zuvor ausgegebenen 8-stelligen Recovery-Codes.',
					},
				},
			},
			environment: {
				baseUrl: 'Oeffentliche API-Origin.',
				apiKey: 'Owner-Dashboard API-Schluessel. Nur serverseitig speichern.',
				defaultRole: 'Rollen-/RBAC-Wert, den du dem Auth-Benutzer zuweist.',
			},
		},
		console: {
			...en.getStarted.console,
			launching: 'Starte AuthFlow™ Linux Console v1.0 ...',
			connected: 'Verbunden mit api.authflow.net',
			sending: '> Sende {method} {path}',
			waiting: '> Warte auf Antwort ...',
			processExited: '[Prozess mit Code {code} beendet]',
			status: {
				...en.getStarted.console.status,
				defaultSuccess: 'HTTP/1.1 200 OK (Beispiel)',
				signup: { ...en.getStarted.console.status.signup, success: 'HTTP/1.1 201 Created (Beispiel)', alt409: '# alt: HTTP/1.1 409 Conflict wenn email+role bereits existiert' },
				login: { ...en.getStarted.console.status.login, success: 'HTTP/1.1 200 OK (Beispiel)', alt2fa: '# alt: payload mit requires2FA/tempToken wenn 2FA aktiv ist' },
				verifyEmail: { ...en.getStarted.console.status.verifyEmail, success: 'HTTP/1.1 200 OK (Beispiel)', alt401: '# alt: HTTP/1.1 401 Unauthorized bei ungueltigem oder abgelaufenem Verifizierungs-Token' },
				validate: { ...en.getStarted.console.status.validate, success: 'HTTP/1.1 200 OK (Beispiel)', alt401: '# alt: HTTP/1.1 401 Unauthorized bei ungueltigem oder abgelaufenem Session-Token' },
				forgotPassword: { ...en.getStarted.console.status.forgotPassword, success: 'HTTP/1.1 200 OK (enumeration-safe Antwort)' },
				changePassword: { ...en.getStarted.console.status.changePassword, success: 'HTTP/1.1 200 OK (Beispiel)', noJsonBody: '# kein JSON-Body bei Erfolg' },
			},
			failure: {
				...en.getStarted.console.failure,
				signup: { ...en.getStarted.console.failure.signup, status: 'HTTP/1.1 409 Conflict (Beispiel)', extra: '# Fehlerszenario: doppelte email+role' },
				login: { ...en.getStarted.console.failure.login, status: 'HTTP/1.1 400 Bad Request (Beispiel)', extra: '# Fehlerszenario: ungueltige Zugangsdaten oder Rollen-Mismatch' },
				verifyEmail: { ...en.getStarted.console.failure.verifyEmail, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: veralteter Verifizierungs-Token' },
				validate: { ...en.getStarted.console.failure.validate, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: abgelaufenes Session-Token' },
				me: { ...en.getStarted.console.failure.me, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: fehlendes oder ungueltiges sessionToken' },
				logout: { ...en.getStarted.console.failure.logout, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: ungueltiges sessionToken' },
				changePassword: { ...en.getStarted.console.failure.changePassword, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: oldPassword ungueltig oder Session abgelaufen' },
				resendVerifyEmail: { ...en.getStarted.console.failure.resendVerifyEmail, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: veraltetes foobar Token oder ungueltiger api_key' },
				fooBar: { ...en.getStarted.console.failure.fooBar, status: 'HTTP/1.1 400 Bad Request (Beispiel)', extra: '# Fehlerszenario: fehlende identity oder api_key' },
				forgotPassword: { ...en.getStarted.console.failure.forgotPassword, status: 'HTTP/1.1 400 Bad Request (Beispiel)', extra: '# Fehlerszenario: fehlende email oder api_key' },
				resetPassword: { ...en.getStarted.console.failure.resetPassword, status: 'HTTP/1.1 401 Unauthorized (Beispiel)', extra: '# Fehlerszenario: veralteter Reset-Token' },
				default: { ...en.getStarted.console.failure.default, status: 'HTTP/1.1 400 Bad Request (Beispiel)', extra: '# Fehlerszenario' },
			},
		},
		pageContent: {
			...en.getStarted.pageContent,
			badge: 'Auth Produktreferenz',
			title: 'AuthFlow™ API-Dokumentation',
			titleAccent: 'fuer Organisationsinhaber',
			description: 'Diese Get-Started-Seite dokumentiert unsere oeffentliche Auth-API fuer Benutzer deiner Organisation. AuthFlow™ bietet insgesamt 20 /auth Routen.',
			downloadCollection: 'Insomnia-Collection herunterladen',
			createAccount: 'Owner-Konto erstellen',
			cloneStarterOnGitHub: 'Next.js Starter klonen',
			starterInfoLabel: 'Wichtige Sicherheitsinformationen zum Next.js Starter',
			starterWarningTitle: 'Nur fuer Prototypen und Proofs of Concept',
			starterWarningPrototype: 'Der authflow-nextjs-starter ist ausschliesslich fuer Prototypen und Proof-of-Concept-Frontends gedacht. Er ist keine produktionsreife Browser-Integration.',
			starterWarningSecret: 'Lege niemals einen AuthFlow API-Schluessel in produktivem Frontend-Code, browser-sichtbaren Umgebungsvariablen, statischen Assets oder Client-Bundles ab. Alles, was an einen Browser ausgeliefert wird, kann von Benutzern und Angreifern gelesen werden.',
			starterWarningProduction: 'Leite Authentifizierungsanfragen in der Produktion ueber ein vertrauenswuerdiges serverseitiges Backend oder den AuthFlow ExpressJS Proxy und speichere den API-Schluessel in serverseitigen Umgebungsvariablen oder einem verwalteten Secret Store.',
			apiKeyWarningTitle: 'Gib deinen AuthFlow API-Schluessel niemals in produktivem Browser-Code preis.',
			apiKeyWarningBody: 'API-Schluessel muessen auf einer von dir kontrollierten Infrastruktur bleiben. Bette sie nicht in JavaScript-Bundles, HTML, oeffentliche Umgebungsvariablen, mobile Web-Assets, Logs oder direkte Browser-Netzwerkanfragen ein. Nutze diesen ExpressJS Proxy oder dein eigenes Backend, damit der Schluessel serverseitig bleibt.',
			integrationRulesTitle: 'Integrationsregeln',
			integrationRulesRules: ['Organisationsinhaber rufen AuthFlow™ nur aus serverseitigem Code auf.', 'Der Owner-API-Schluessel ist fuer Kern-Sessionrouten erforderlich.', 'fooBar direkt vor jedem Sign-up/Login frisch abrufen.', 'Bei requires2FA muss ein dokumentierter /auth/2fa Austausch erfolgen.'],
			ownerAssetsTitle: 'Owner-Assets',
			ownerAssetsText: 'Nutze die exakte Collection, die dein Team direkt in Insomnia importieren kann.',
			collectionIncludes: 'Die Collection enthaelt:',
			collectionItems: ['7 oeffentliche /auth Session-Routen', '3 oeffentliche /auth Passwortmanagement-Routen', '2 oeffentliche /auth E-Mail-Verifizierungs-Routen', '8 oeffentliche /auth/2fa Routen', 'Umgebungsvariablen fuer API-Key, Rolle/RBAC, Session-Token, TOTP, temp token und Recovery-Code-Flows'],
			checklistTitle: 'Implementierungs-Checkliste',
			checklistSubtitle: 'Empfohlener Owner-Workflow zur Integration von AuthFlow™ in die Organisationsauthentifizierung.',
			configStep: '1. Serverseitige Secrets konfigurieren',
			implementStep: '2. Serverseitige Auth implementieren',
			connectStep: '3. Frontend verbinden',
			connectStepSecurityNote: 'Browser-Code darf keine AuthFlow™ API-Secrets wie den Owner-API-Schluessel speichern.',
			implementStepRules: ['/auth/fooBar abrufen', '/auth/signUp oder /auth/login aufrufen', 'Session-Tokens sicher speichern', '/auth/validate, /auth/me, /auth/changePassword und /auth/logout auf geschuetzten Routen verwenden'],
			connectStepRules: ['Login-/Sign-up-Formulare absenden', '2FA-Prompts behandeln, wenn requires2FA zurueckkommt', 'App-Sessions in sicheren Cookies speichern', 'Aktuellen Benutzer ueber Session-Endpunktantworten laden'],
			sessionEndpointsTitle: 'Session-Endpunkte',
			sessionEndpointsSubtitle: 'Diese sieben Routen entsprechen authProduct.session vom Backend-Root-Endpunkt.',
			passwordMgmtTitle: 'Passwortverwaltungs-Endpunkte',
			passwordMgmtSubtitle: 'Diese drei Routen entsprechen authProduct.passwordManagement.',
			emailVerificationTitle: 'E-Mail-Verifizierungs-Endpunkte',
			emailVerificationSubtitle: 'Diese zwei Routen entsprechen authProduct.emailVerification.',
			twoFactorTitle: '2FA-Endpunkte',
			twoFactorSubtitle: 'Diese acht Routen entsprechen authProduct.twoFactor.',
			serviceExampleTitle: 'Service-Beispiel',
			securityRequirementsTitle: 'Sicherheitsanforderungen',
			securityRequirements: ['AUTHFLOW_API_KEY serverseitig und verschluesselt halten.', 'HTTP-only Secure Cookies fuer Anwendungssessions bevorzugen.', 'AuthFlow™ Sessions vor Auslieferung geschuetzter Daten validieren.', '400, 401, 404, 409 und 500 Antworten explizit behandeln.'],
			readyCtaTitle: 'Bereit, die Unternehmensauthentifizierung zu integrieren?',
			readyCtaDescription: 'Starte mit der Download-Collection, implementiere sichere Integration und nutze den Assistenten auf dieser Seite bei Fragen.',
			proxyTitlePrefix: 'ExpressJS ',
			proxyTitleSuffix: ' Proxy',
			proxyDescriptionPrefix: 'Du kannst das AuthFlow Backend auch ueber dein eigenes ExpressJS Backend proxien. Das ist eine der sichersten Arten, ',
			proxyDescriptionSuffix: ' in deinen Application-Stacks zu verwenden.',
			proxyDetailsRoutes: 'Der Proxy leitet alle AuthFlow /auth/* und /auth/2fa/* Routen weiter, haelt API-Keys serverseitig und reduziert Secret-Exposure im Browser.',
			proxyDetailsDeploy: 'Der Proxy ist Vercel-ready, unterstuetzt lokale Entwicklung sofort und enthaelt Beispiele fuer Sign-up, Login, Passwortfluesse und 2FA.',
			proxyButton: 'Auf GitHub ansehen',
		},
	},
	comparisons: {
		...en.comparisons,
		hub: {
			...en.comparisons.hub,
			breadcrumbRoot: 'Vergleichen',
			breadcrumbCurrent: 'Auth-Produktvergleiche',
			title: 'Auth-Produktvergleiche',
			description: 'Sieh, wie AuthFlow™ im Vergleich zu den populaersten Auth-Plattformen abschneidet. Direkte Feature-Tabellen helfen dir dabei, die richtige Auth-Loesung fuer dein Projekt auszuwaehlen.',
			card: {
				firebase: {
					title: 'Firebase vs. Auth0 vs. AuthFlow™',
					description: 'Vergleiche Google Firebase Authentication mit der Enterprise-Plattform von Auth0 und dem entwicklerorientierten Ansatz von AuthFlow™. So erkennst du schnell, welche Loesung am besten zu deinem Stack passt.',
				},
				supabase: {
					title: 'Supabase vs. Auth0 vs. AuthFlow™',
					description: 'Vergleiche die Open-Source-Authentifizierung von Supabase mit Auth0 und dem fokussierten Auth-Service von AuthFlow™. Besonders hilfreich, wenn du bereits im Supabase-Oekosystem arbeitest.',
				},
			},
			bullets: {
				core: 'Kernfunktionen der Authentifizierung und Sicherheit',
				rbac: '2FA, RBAC und Mandantenfähigkeit',
				supabaseModel: 'Open Source vs. Managed vs. fokussiert',
				pricing: 'Preise und Vendor Lock-in',
				dx: 'Developer Experience und Einrichtungsaufwand',
			},
			viewComparison: 'Vergleich ansehen',
		},
		labels: {
			...en.comparisons.labels,
			fullySupported: 'Vollstaendig unterstuetzt',
			partial: 'Teilweise / eingeschraenkt',
			notSupported: 'Nicht unterstuetzt',
			feature: 'Funktion',
			summary: 'Zusammenfassung',
			startFree: 'Kostenlos mit AuthFlow™ starten',
			alsoSee: 'Siehe auch:',
			providers: {
				firebase: 'Firebase Auth',
				supabase: 'Supabase Auth',
				auth0: 'Auth0',
				authflow: 'AuthFlow™',
			},
			categories: {
				...en.comparisons.labels.categories,
				core: 'Kern-Authentifizierung',
				security: 'Sicherheit',
				userOrg: 'Benutzer- & Organisationsverwaltung',
				dx: 'Developer Experience',
				pricing: 'Preise & Flexibilitaet',
			},
		},
		features: {
			emailPassword: 'E-Mail- und Passwort-Authentifizierung',
			socialLogin: 'Social Login (Google, GitHub usw.)',
			magicLinks: 'Magic Links / Passwortlos',
			smsPhone: 'SMS- / Telefon-Authentifizierung',
			anonymous: 'Anonyme Authentifizierung',
			jwt: 'JWT-Token-Management',
			rs512: 'RS512-Schluesselpaar-Signierung',
			twofa: 'Zwei-Faktor-Authentifizierung (2FA)',
			totp: 'TOTP-Authenticator-App (Google Auth, Authy)',
			backupCodes: '2FA-Backup-Codes',
			emailOtp: '2FA per E-Mail-OTP',
			rateLimiting: 'Rate Limiting',
			emailVerification: 'E-Mail-Verifizierung',
			passwordReset: 'Passwort zuruecksetzen / Passwort vergessen',
			passwordComplexity: 'Durchsetzung von Passwortregeln',
			userDashboard: 'Dashboard zur Benutzerverwaltung',
			rbac: 'Rollenbasierte Zugriffskontrolle (RBAC)',
			multiTenancy: 'Mandantenfähigkeit / Organisationen',
			perOrgApiKeys: 'API-Keys pro Organisation',
			auditLogs: 'Audit- / Aktivitaetsprotokolle',
			userBlocking: 'Benutzersperrung / Suspendierung',
			simpleRest: 'Einfache REST-API (kein SDK noetig)',
			officialSdks: 'Offizielle Client-SDKs',
			customEmailTemplates: 'Individuelle E-Mail-Vorlagen',
			webhooks: 'Webhooks / Event-Callbacks',
			selfHosted: 'Self-Hosted-Option',
			openSource: 'Open Source',
			apiDocs: 'API-Dokumentation',
			integratedDb: 'Integrierte Datenbank (PostgreSQL)',
			authOnly: 'Nur Auth (keine Datenbank erforderlich)',
			freeTier: 'Kostenloser Tarif verfuegbar',
			flatRate: 'Planbare Festpreis-Tarife',
			payPerMau: 'Pay-per-MAU-Modell',
			lowLockIn: 'Geringer Vendor Lock-in',
			lowSetup: 'Geringe Einrichtungs-Komplexitaet',
			noEcosystemBuyIn: 'Nutzbar ohne Oekosystem-Bindung',
		},
		notes: {
			firebase2fa: 'Fuer 2FA ist bei Firebase ein Upgrade auf Identity Platform erforderlich.',
			firebaseRest: 'Firebase ist SDK-first; reine REST-Nutzung erfordert manuellen Token-Austausch.',
			firebaseLockIn: 'Firebase ist eng an das Google/Firebase-Oekosystem gekoppelt.',
			supabaseRls: 'Supabase verwendet Row-Level-Security-(RLS)-Richtlinien in Postgres.',
			supabaseDb: 'Supabase Auth ist eng mit der eigenen Postgres-Datenbank integriert.',
			supabaseLockIn: 'Open Source reduziert Lock-in, aber die Auth-Schicht bleibt eng an den Postgres-Stack gekoppelt.',
			supabaseAuthOnly: 'Supabase kann nur fuer Auth genutzt werden, ist aber als komplette Backend-Plattform konzipiert.',
		},
		firebase: {
			...en.comparisons.firebase,
			breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
			title: 'Firebase vs. Auth0 vs. AuthFlow™',
			description: 'Ein direkter Feature-Vergleich zwischen Google Firebase Authentication, Okta Auth0 und AuthFlow™, damit du die passende Auth-Schicht fuer deine Anwendung auswaehlen kannst.',
			summary: {
				firebaseTitle: 'Firebase Authentication',
				firebaseBody: 'Am besten fuer Teams geeignet, die bereits tief im Google/Firebase-Oekosystem stecken. Grosszuegiger Free Tier und bequeme SDK-Integration, aber deutlicher Lock-in und fuer 2FA ist Identity Platform noetig.',
				auth0Title: 'Auth0',
				auth0Body: 'Der groesste Funktionsumfang der drei Produkte: SAML, OIDC, Enterprise SSO und viele Anpassungsmoeglichkeiten. Ideal fuer grosse Teams mit komplexen Enterprise-Anforderungen, aber die Preise steigen stark mit den MAU.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Die richtige Wahl fuer Teams, die sichere E-Mail/Passwort-Authentifizierung mit RS512 JWT, 2FA und RBAC wollen, ohne sich an ein grosses Oekosystem zu binden. Einfache REST-API, planbare Preise und wenig Einrichtungsaufwand.',
			},
			alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
		},
		supabase: {
			...en.comparisons.supabase,
			breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
			title: 'Supabase vs. Auth0 vs. AuthFlow™',
			description: 'Ein direkter Feature-Vergleich zwischen Supabase Auth, Auth0 und AuthFlow™, damit du die passende Auth-Schicht fuer deine Anwendung auswaehlen kannst.',
			summary: {
				supabaseTitle: 'Supabase Auth',
				supabaseBody: 'Ideal fuer Teams, die ein Open-Source-Backend moechten, das sich selbst hosten laesst. Supabase Auth bietet Social Login, Magic Links und tiefe Postgres-Integration, besonders sinnvoll wenn du Supabase bereits als Datenbank nutzt.',
				auth0Title: 'Auth0',
				auth0Body: 'Das umfassendste Feature-Set mit SAML, OIDC, Enterprise SSO und tiefer Anpassbarkeit. Stark fuer grosse Teams mit hohen Compliance-Anforderungen, aber mit schnell steigenden Kosten pro monatlich aktivem Nutzer.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Die passende Wahl, wenn du fokussierte und verlaessliche E-Mail/Passwort-Authentifizierung mit RS512 JWT, 2FA und RBAC brauchst, ohne Plattform-Lock-in. Einfache REST-API, planbarer Festpreis und minimale Einrichtung.',
			},
			alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
		},
	},
	features: {
		title: 'Warum AuthFlow™ anders ist',
		description: 'Wir konzentrieren uns auf E-Mail/Passwort-Authentifizierung mit JWT-Tokens - die Grundlage sicherer Web-Apps. Statt alles auf einmal zu machen, machen wir eine Sache aussergewoehnlich gut.',
		emailPassword: {
			title: 'E-Mail/Passwort-Login',
			description: 'Einfaches, sicheres E-Mail/Passwort-Login, das zuverlaessig funktioniert. Keine unnoetige Komplexitaet - nur Login, den Nutzer verstehen.',
		},
		jwtTokens: {
			title: 'JWT-Token-Management',
			description: 'Sauberes JWT-Handling fuer Sessions, mit sicherer Speicherung und automatischer Erneuerung. Industriestandard-Tokens, die sich nahtlos in deine API integrieren.',
		},
		developerApi: {
			title: 'Developer-First API',
			description: 'REST-API mit umfassender Dokumentation, SDKs und Entwickler-Tools. Von Entwicklern fuer den DevSecOps-Workflow gebaut.',
		},
	},
	testimonials: {
		title: 'Von Entwicklern weltweit vertraut',
		testimonial1: {
			text: 'AuthFlow™ hat uns Monate Entwicklungszeit gespart. Die Integration war nahtlos und die Sicherheitsfunktionen sind enterprise-tauglich.',
			author: 'Sarah Johnson',
			role: 'CTO, TechStart',
		},
		testimonial2: {
			text: 'Das Analytics-Dashboard liefert uns wertvolle Einblicke in das Nutzerverhalten. Die beste Auth-Loesung, die wir verwendet haben.',
			author: 'Mike Rodriguez',
			role: 'Lead Developer, AppCorp',
		},
		testimonial3: {
			text: 'Felsstabile Zuverlaessigkeit und hervorragender Support. Unsere Nutzer lieben die reibungslose Authentifizierung.',
			author: 'Alex Liu',
			role: 'Product Manager, InnovateLab',
		},
	},
	signIn: {
		title: 'Willkommen zurueck',
		subtitle: 'Melde dich bei deiner E-Mail/Passwort-Authentifizierung an',
		card: {
			title: 'Organisations-Anmeldung',
			description: 'Gib die E-Mail des Organisationsinhabers ein, um auf dein JWT-Authentifizierungs-Dashboard zuzugreifen',
		},
		form: {
			email: { label: 'E-Mail', placeholder: 'owner@deineorganisation.com' },
			password: { label: 'Passwort', placeholder: 'Passwort eingeben' },
			signIn: 'Anmelden',
			signingIn: 'Melde an...',
			noAccount: { text: 'Noch keine Organisation?', link: 'Jetzt erstellen' },
		},
		errors: {
			emailRequired: 'E-Mail ist erforderlich',
			failed: 'Anmeldung fehlgeschlagen',
			unexpected: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
		},
		success: { message: 'Erfolgreich angemeldet!' },
		agreement: {
			text: 'Mit der Anmeldung stimmst du unseren',
			terms: 'Nutzungsbedingungen',
			and: 'und',
			privacy: 'Datenschutzrichtlinien',
		},
	},
	signUp: {
		title: 'Erstelle deine Organisation',
		subtitle: 'Starte deine Organisation mit E-Mail/Passwort-Authentifizierung',
		card: {
			title: 'Organisation erstellen',
			description: 'Richte deine Organisation ein, um mit E-Mail/Passwort-Authentifizierung und JWT-Tokens zu starten',
		},
		form: {
			organizationName: { label: 'Organisationsname', placeholder: 'Deine Organisation' },
			organizationWebsite: { label: 'Webseite der Organisation', placeholder: 'deineorganisation.com' },
			emailOwner: { label: 'E-Mail des Inhabers', placeholder: 'owner@deineorganisation.com' },
			password: { label: 'Passwort', placeholder: 'Erstelle ein starkes Passwort' },
			confirmPassword: { label: 'Passwort bestaetigen', placeholder: 'Bestaetige dein Passwort' },
			agreeToTerms: 'Ich stimme den Nutzungsbedingungen und der Datenschutzrichtlinie zu',
			acceptMarketing: 'Produkt-Updates und Marketing-E-Mails senden',
			createOrganization: 'Organisation erstellen',
			creatingOrganization: 'Erstelle Organisation...',
			haveAccount: { text: 'Du hast bereits ein Konto?', link: 'Anmelden' },
		},
		errors: {
			organizationNameRequired: 'Organisationsname ist erforderlich',
			organizationWebsiteRequired: 'Webseite der Organisation ist erforderlich',
			emailRequired: 'E-Mail ist erforderlich',
			passwordRequired: 'Passwort ist erforderlich',
			passwordsDoNotMatch: 'Passwoerter stimmen nicht ueberein',
			agreeToTermsRequired: 'Du musst den Nutzungsbedingungen und der Datenschutzrichtlinie zustimmen',
			failed: 'Erstellen der Organisation fehlgeschlagen',
			unexpected: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut.',
		},
		success: { message: 'Organisation erfolgreich erstellt!' },
		trial: {
			description: 'Beginne noch heute mit der Verwaltung der Authentifizierung deiner Organisation.',
			features: {
				emailPassword: 'E-Mail/Passwort-Authentifizierung',
				jwtTokens: 'JWT-Token-Sicherheit',
				simpleLogin: 'Einfaches Login',
			},
		},
	},
	common: {
		loading: 'Laedt...',
		error: 'Ein Fehler ist aufgetreten',
		success: 'Erfolg',
		cancel: 'Abbrechen',
		save: 'Speichern',
		delete: 'Loeschen',
		edit: 'Bearbeiten',
		view: 'Ansehen',
		back: 'Zurueck',
		next: 'Weiter',
		previous: 'Vorherige',
		language: 'Sprache',
	},
	seo: {
		title: 'AuthFlow™ - Sichere Authentifizierung einfach gemacht',
		description: 'Token-basierte Authentifizierung fuer Webanwendungen. Einfache Integration, Enterprise-Sicherheit und entwicklerfreundliche API. Starte heute deine kostenlose Testphase.',
		keywords: ['authentifizierung', 'auth', 'sicherheit', 'API', 'token-basierte auth', 'JWT', 'entwickler-tools', 'web-sicherheit', 'benutzerverwaltung'],
	},
	footer: {
		description: 'Einfache, zuverlaessige E-Mail/Passwort-Authentifizierung mit JWT-Tokens. Weltweit von Entwicklern vertraut.',
		product: 'Produkt',
		resources: 'Ressourcen',
		company: 'Unternehmen',
		apiReference: 'API-Referenz',
		about: 'Ueber uns',
		support: 'Support',
		privacyPolicy: 'Datenschutzrichtlinie',
		termsOfService: 'Nutzungsbedingungen',
		copyright: '© 2024 AuthFlow™. Alle Rechte vorbehalten.',
	},
	pricing: {
		title: 'AuthFlow™ Preise - Einfache Kosten fuer E-Mail/Passwort-Authentifizierung',
		description: 'Einfache, transparente Preise fuer E-Mail/Passwort-Authentifizierung mit JWT-Tokens. Starte kostenlos und skaliere mit deinem Wachstum. Keine versteckten Gebuehren.',
		keywords: ['authentifizierungs preise', 'email passwort preise', 'JWT preise', 'einfache auth preise', 'developer auth preise', 'zuverlaessige auth kosten', 'sicheres login preise', 'token-basierte auth preise', 'kostenlose auth testphase'],
		ogTitle: 'AuthFlow™ Preise - Einfache Kosten fuer E-Mail/Passwort-Authentifizierung',
		ogDescription: 'Waehle den perfekten Plan fuer deine Anforderungen. Starte kostenlos und skaliere mit zuverlaessiger E-Mail/Passwort-Authentifizierung und JWT-Tokens.',
		hero: {
			title: 'Einfaches, transparentes',
			titleAccent: 'Authentifizierungs-Pricing',
			description: 'Waehle den passenden Plan fuer deine Authentifizierungsanforderungen. Starte kostenlos und wachse mit E-Mail/Passwort-Authentifizierung ueber JWT-Sessions. Keine versteckten Kosten.',
		},
		breadcrumb: { product: 'Produkt', pricing: 'Preise' },
		plans: {
			starter: {
				name: 'Starter',
				description: 'Perfekt fuer kleine Projekte und das Testen von E-Mail/Passwort-Authentifizierung',
				price: '$0',
				period: '/Monat',
				features: {
					users: 'Bis zu 10 monatlich aktive Nutzer',
					basicAuth: 'Basis E-Mail/Passwort-Authentifizierung',
					support: 'Standard-Support',
				},
				cta: 'Kostenlos starten',
			},
			pro: {
				name: 'Pro',
				description: 'Fuer wachsende Teams mit Bedarf an zuverlaessiger E-Mail/Passwort-Authentifizierung',
				price: '$9.99',
				period: 'erster Monat, dann $19.99/Monat',
				badge: 'Am beliebtesten',
				features: {
					users: 'Unbegrenzte monatlich aktive Nutzer',
					advancedAuth: 'Erweiterte E-Mail/Passwort-Authentifizierung',
					support: 'Prioritaets-Support',
				},
				cta: 'Kostenlose Testphase starten',
				monthlyCta: 'Monatlich kaufen',
				annualCta: 'Jaehrlich kaufen',
			},
		},
		faq: {
			title: 'Hauefig gestellte Fragen',
			subtitle: 'Alles Wichtige zu Preisen und Plaenen fuer E-Mail/Passwort-Authentifizierung.',
			questions: {
				mau: {
					question: 'Was zaehlt als monatlich aktiver Nutzer?',
					answer: 'Ein monatlich aktiver Nutzer (MAU) ist ein eindeutiger Nutzer, der sich mindestens einmal pro Kalendermonat authentifiziert.',
				},
				changePlans: {
					question: 'Kann ich den Plan jederzeit wechseln?',
					answer: 'Ja, Upgrades oder Downgrades sind jederzeit moeglich. Aenderungen gelten sofort und werden anteilig abgerechnet.',
				},
				freeTrial: {
					question: 'Gibt es eine kostenlose Testphase?',
					answer: 'Ja, alle kostenpflichtigen Plaene enthalten eine 3-taegige Testphase. Keine Kreditkarte zum Start erforderlich.',
				},
				paymentMethods: {
					question: 'Welche Zahlungsmethoden akzeptiert ihr?',
					answer: 'Wir akzeptieren alle gaengigen Kreditkarten sowie Google Pay und Apple Pay.',
				},
			},
		},
		cta: {
			title: 'Bereit loszulegen?',
			description: 'Schliess dich tausenden Entwicklern an, die AuthFlow™ fuer zuverlaessige E-Mail/Passwort-Authentifizierung nutzen. Starte heute kostenlos.',
			startTrial: 'Kostenlose Testphase starten',
			contactSales: 'Vertrieb kontaktieren',
		},
		footer: {
			description: 'Einfache, zuverlaessige E-Mail/Passwort-Authentifizierung mit JWT-Tokens. Weltweit von Entwicklern vertraut.',
			product: { title: 'Produkt', features: 'Funktionen', pricing: 'Preise', apiReference: 'API-Referenz' },
			resources: { title: 'Ressourcen', gettingStarted: 'Erste Schritte', apiReference: 'API-Referenz', support: 'Support' },
			company: { title: 'Unternehmen', about: 'Ueber uns', privacy: 'Datenschutzrichtlinie', terms: 'Nutzungsbedingungen' },
			copyright: '© 2024 AuthFlow™. Alle Rechte vorbehalten.',
		},
	},
	agent: {
		chatbot: {
			title: 'AuthFlow™ Assistent',
			inputPlaceholder: 'Frage zu /auth oder 2FA-Integration...',
			greeting: 'Ich begleite Organisationsinhaber durch den exakten AuthFlow™ auth-user Vertrag. Frage mich zu Owner API-Key Setup, /auth Endpunkten, 2FA-Flows, der Insomnia-Collection, Frontend-Backend-Grenzen oder Account-Loeschung in Settings.',
			downloadIntro: 'Nutze diese direkte Download-Karte, damit dein Team die Owner-Collection sofort importieren kann.',
			downloadTitle: 'Insomnia-Collections herunterladen',
			downloadButton: 'Herunterladen',
			noAnswer: 'Ich habe keine brauchbare Antwort vom Agenten erhalten. Frage nach einem bestimmten Endpunkt, 2FA-Flow oder Backend-Integrationsschritt.',
			error: 'Beim Kontakt mit dem Assistenten ist ein Fehler aufgetreten. Du kannst weiterhin nach dem /auth-Vertrag, 2FA-Flows oder der Insomnia-Collection fragen und es erneut versuchen.',
			toolNotFound: 'Tool nicht gefunden',
		},
		tools: {
			verificationRecoveryDescription: 'Endpunkte fuer E-Mail-Verifizierung und Passwort-Wiederherstellung',
			accountSteps: ['1. Als Organisationsinhaber unter https://www.authflow.net/sign-up registrieren', '2. Organisation im Owner-Dashboard erstellen', '3. Organisations-API-Key im Dashboard kopieren', '4. Rollenwerte fuer Auth-Benutzer festlegen', '5. AuthFlow™ auth-user Insomnia-Collection herunterladen', '6. Collection und exakten Backend-Vertrag an das Integrationsteam weitergeben'],
			accountManagement: ['Um eine Organisation dauerhaft zu loeschen, gehe zur Settings-Seite im AuthFlow™ Dashboard.', 'Im Bereich Delete Account DELETE eingeben, um unwiderruflich zu bestaetigen.'],
			reminder: 'Der Owner API-Key gehoert ausschliesslich ins Firmen-Backend.',
			environmentNotes: ['AUTHFLOW_API_KEY nur serverseitig verwenden.', 'AUTHFLOW_DEFAULT_ROLE ist optional, aber oft hilfreich.', 'Das Frontend soll eigene Backend-Routen aufrufen, nicht AuthFlow™ direkt.'],
			backendGuidance: ['/auth/fooBar unmittelbar vor /auth/signUp oder /auth/login abrufen.', 'Exakte Parameternamen aus dem oeffentlichen Vertrag verwenden.', 'Wenn /auth/login requires2FA liefert, mit der passenden /auth/2fa Route fortfahren.', 'Aktuellen Benutzer ueber Backend-Routen validieren/abrufen und nur eigene Session ans Frontend geben.'],
			insomniaContains: ['Alle 12 oeffentlichen /auth Endpunkte (inkl. verify-email, resend-verify-email, forgot-password, reset-password, deleteUser)', 'Alle 8 oeffentlichen /auth/2fa Endpunkte', 'Umgebungsvariablen fuer API-Key, Rolle, fooBar-Token, tempToken, Session-Token, TOTP, E-Mail-OTP und Recovery-Codes'],
			troubleshoot: {
				solutions: {
					cors: 'Wenn der Browser AuthFlow™ direkt aufruft, dort zuerst stoppen. Browser -> dein Backend -> AuthFlow™.',
					'401_unauthorized': 'Pruefe, ob api_key, role und email exakt zu /auth/fooBar bzw. Benutzererstellung passen.',
					token_validation: 'Fuer /auth/validate exakt sessionToken + email nutzen; tempToken nicht verwechseln.',
					connection_failed: 'AUTHFLOW_BASE_URL auf https://api.authflow.net und Backend-Konnektivitaet pruefen.',
					api_key_invalid: 'Der Owner API-Key muss der Dashboard-Key mit Praefix af_ sein.',
					foobar_expired: 'fooBar laeuft schnell ab; direkt vor Sign-up/Login neu abrufen.',
					verification_link: 'Verifizierungs-Token muss gueltig sein und als Query an /auth/verify-email gehen.',
					password_reset: 'Zuerst /auth/forgot-password, danach /auth/reset-password mit Token aus der E-Mail.',
					two_factor_flow: 'Wenn Login requires2FA liefert, tempToken nur in den passenden /auth/2fa Routen verwenden.',
					organization_deletion: 'Dauerhafte Organisationsloeschung in Settings > Delete Account mit DELETE bestaetigen.',
					other: 'Anfrage mit oeffentlichem Vertrag abgleichen: Parameter, HTTP-Methode und Position (query/body/header).',
				},
				commonIssues: ['Frontend ruft AuthFlow™ direkt auf', 'Fehlender api_key oder falsche role bei /auth/fooBar oder /auth/login', 'Falsche oldPassword/newPassword Nutzung bei /auth/changePassword', 'Verwechslung von tempToken und sessionToken', 'Abgelaufenes oder ungueltiges Verifizierungs-Token', '/auth/forgot-password vor /auth/reset-password ausgelassen', '2FA-Verifizierung nach requires2FA uebersprungen', 'Organisationsloeschung ausserhalb des Settings-Flows versucht'],
			},
		},
	},
} as const
